/**
 * @fileoverview POST handler for the "/companies/:company_id/sender_verification/subuser" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdSenderVerificationSubuserCacheKeys } from "./constants";
import type {
  PostCompaniesCompanyIdSenderVerificationSubuserProps,
  CompaniesCompanyIdSenderVerificationSubuserResult,
} from "./types";

export const postCompaniesCompanyIdSenderVerificationSubuser = reactQueryMutationAdapter(
  companiesCompanyIdSenderVerificationSubuserCacheKeys,
  (
    props: PostCompaniesCompanyIdSenderVerificationSubuserProps
  ): Promise<CompaniesCompanyIdSenderVerificationSubuserResult> => {
    return fetch(`/companies/${props.companyId}/sender_verification/subuser`, "POST", props);
  }
);
